import { render, staticRenderFns } from "./appealDetail.vue?vue&type=template&id=3174df72&scoped=true&"
import script from "./appealDetail.vue?vue&type=script&lang=js&"
export * from "./appealDetail.vue?vue&type=script&lang=js&"
import style0 from "./appealDetail.vue?vue&type=style&index=0&id=3174df72&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3174df72",
  null
  
)

export default component.exports